<div (click)="focus()"
    class="d-flex rounded-2 background-light-gray m-1 p-2 gap-2 pointer pointer-hover-blue">
    <app-paddock-svg class="img-fluid img-max px-2" [colored]="true"/>
    <div class="d-flex flex-column justify-content-center">
        <div class="fw-bold text-truncate">{{ paddock().name }}</div>
    </div>
</div>
